/**
 * <PdfPageSkeleton> — la forme d'un document qui arrive : une feuille, son titre, ses paragraphes.
 *
 * Posé par les deux visionneuses (`PdfDisplay.web` et `PdfInline.web` pendant que pdf.js
 * charge, `PdfDisplay` natif pendant que `react-native-pdf` télécharge) : la feuille claire sur le fond de la
 * visionneuse, sous son propre balayage, après le seuil.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Stack } from "../../atoms/containers/Stack"
import { DelayedSkeleton, Skeleton } from "../../atoms/Skeleton"

/** Deux paragraphes : la dernière ligne de chacun s'arrête avant le bord, comme un vrai texte. */
const PARAGRAPHS = [
    ["100%", "100%", "100%", "55%"],
    ["100%", "100%", "70%"],
] as const

export function PdfPageSkeleton() {
    return (
        <DelayedSkeleton accessibilityLabel="Chargement du document" style={styles.sheet}>
            <Stack gap="4">
                <Skeleton textSize="text-xl" width={200} />
                {PARAGRAPHS.map((lines, paragraph) => (
                    <Stack key={paragraph} gap="1">
                        {lines.map((width, index) => (
                            <Skeleton key={index} textSize="text-md" width={width} />
                        ))}
                    </Stack>
                ))}
            </Stack>
        </DelayedSkeleton>
    )
}

const styles = StyleSheet.create((theme) => ({
    /** La feuille : la surface de page, centrée, à la largeur d'une page lue sur un écran. */
    sheet: {
        width: "90%",
        maxWidth: 560,
        padding: theme.spacing["6"],
        borderRadius: theme.radius.md,
        backgroundColor: theme.colors.surface,
    },
}))
